module.exports = __webpack_public_path__ + "static/media/payPal.bef90867.svg";